/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';

const Payout = ({ children }) => {
    return <div className="container mb-5 px-0">{children}</div>;
};

Payout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Payout;
